import styled from 'styled-components';

const Label = styled.label`
  display: block;
  text-transform: capitalize;
  color: #4F4F4F;
  font-weight: 700;
  margin: 5px 0;
`;

export default Label;



// WEBPACK FOOTER //
// ./src/components/RecipeForm/styled/Label.js